import { useNavigate } from 'react-router-dom';
import { FileSignature } from 'lucide-react';
import { PageHeader } from '@/components/page-header';
import { EmptyState } from '@/components/empty-state';
import { SkeletonList } from '@/components/skeleton';
import { DataList, DataListRow } from '@/components/data-list';
import { StatusPill } from '@/components/status-dot';
import { usePortalProposals } from '@/lib/portal-approvables';
import { statusTone } from '@/lib/approvable-status';
import { dollars, formatDate, formatStatus } from '@/lib/format';

export function PortalProposals() {
  const { data, isLoading } = usePortalProposals();
  const navigate = useNavigate();
  const rows = data?.data;

  return (
    <div className="space-y-5">
      <PageHeader
        icon={FileSignature}
        title="Proposals"
        subtitle="Review and respond to proposals from the Mehrutherm team."
      />

      {isLoading ? (
        <SkeletonList rows={4} />
      ) : !rows || rows.length === 0 ? (
        <EmptyState
          icon={FileSignature}
          title="No proposals yet"
          description="When Mehrutherm sends you a proposal, it'll show up here to review."
        />
      ) : (
        <DataList>
          {rows.map((row) => (
            <DataListRow key={row.id} onClick={() => navigate(`/proposals/${row.id}`)} interactive>
              <div className="min-w-0 flex-1">
                <div className="truncate font-medium text-foreground">{row.title}</div>
                <div className="mt-0.5 text-xs text-muted-foreground">
                  {row.sent_at ? `Sent ${formatDate(row.sent_at)}` : `Created ${formatDate(row.created_at)}`}
                </div>
              </div>
              {row.total_cents != null ? (
                <div className="shrink-0 text-sm font-medium tabular-nums text-foreground">
                  {dollars(row.total_cents)}
                </div>
              ) : null}
              <StatusPill tone={statusTone(row.status)}>{formatStatus(row.status)}</StatusPill>
            </DataListRow>
          ))}
        </DataList>
      )}
    </div>
  );
}
